import { CSSProperties } from 'react';
import { ColumnDescription } from 'react-bootstrap-table-next';
import { Dispatch } from 'redux';
import { BriefProductEntity } from '../../schemas';
import { imageFormatter } from '../Products/components/ProductsTable/formatters';
import { actionFormatter, FormatterExtraData, nameFormatter } from './formatters';

const columns = (
  dispatch: Dispatch
): ColumnDescription<BriefProductEntity, FormatterExtraData>[] => [
  {
    dataField: 'productVersion.image',
    formatter: imageFormatter,
    headerStyle: () => ({ width: '50px' }),
    text: '',
  },
  {
    dataField: 'productVersion.name',
    formatter: nameFormatter,
    headerStyle: () => ({ width: '40%' }),
    text: 'Name',
  },
  { dataField: 'message', text: 'Message' },
  {
    dataField: '',
    formatter: actionFormatter,
    formatExtraData: { dispatch },
    headerStyle: () => ({ width: '100px' } as CSSProperties),
    style: () => ({ paddingRight: 20, textAlign: 'right' } as CSSProperties),
    text: '',
  },
];

export default columns;
